export const TIME_SETTINGS_KEY = '___nqtr-time_manager_settings___';
export const TIME_DATA_KEY = '___nqtr-time_manager_data___';

